import { asset } from '../../../services/assetResolverService';
import cx from 'classnames';

type TSpecIconProps = {
  class: string;
  spec: string;
  className?: string;
  size?: number;
  lazy?: boolean;
  style?: React.CSSProperties;
  iconClassName?: string;
};

const DEFAULT_SPRITE_SIZE = 64;

function cataSpecRemap(spec: string) {
  if (spec === 'feral-combat') {
    return 'feral';
  } else if (spec === 'combat') {
    return 'outlaw';
  } else {
    return spec;
  }
}

export function SpecIcon(props: TSpecIconProps) {
  const { className, size, style } = props;

  if (!props.class || !props.spec) {
    return (
      <img
        src={asset('/images/questionmark.jpg')}
        className={className}
        alt="unknown spec"
        style={size ? { width: size, height: size } : {}}
      />
    );
  }

  let scale: string = '1';
  if (size) {
    scale = String(size / DEFAULT_SPRITE_SIZE);
  }

  return (
    <div
      className={cx('sprite-icon', props.iconClassName)}
      style={{
        ...(size ? { width: size, height: size } : {}),
        position: 'relative',
        ...style
      }}
    >
      <div
        className="sprite-scaler"
        style={{
          ...(size ? { transform: `scale(${scale})` } : {}),
          position: 'absolute',
          top: '0',
          left: '0',
          transformOrigin: '0 0'
        }}
      >
        <div className={`spec_${props.class}_${cataSpecRemap(props.spec)}`} />
      </div>
    </div>
  );
}
